import { useState, useEffect } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputTextArea from "../../helpers/InputTextArea";
import InputUploader from "../../helpers/InputUploader";
import InputChecbox from "../../helpers/InputCheckbox";


function CloudNew(props)
{

    
    const [view, setView] = useState('btn');

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({
        nazwa:  "",  
        grupy: [],
        rodzice: 0,
        rodzice_valid: true,
        pracownicy: 0,
        pracownicy_valid: true,
    });

    const [plgr, setPlGr] = useState({
        result: []
    });


    const valChangeListener = (filedName, val, correct, msg) => {

     //   console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        var tabCheck = filedName.split('@');
        if(tabCheck.length == 2)
        {
            var tabName = tabCheck[0];
            var tabInx  = tabCheck[1];
            var tRef = row[tabName];
            if(correct)tRef[tabInx] = val;
            if(!correct)tRef[tabInx] = "";

            setRow( {...row, [tabName]:tRef } );   
            return;
        }

        if(correct)
        {
          setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
        }else   setRow( {...row, [filedName]:'',  [filedName+"_valid"]:correct } ); 

    }  



    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }



    const getDataPlGr = () => {
       
 
        var req = {
        
        };

        fetch( Config.url + '/rest_v1,places_groups', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    setPlGr(res); 
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;
    }



    const saveData = (e) => {


        if(row.nazwa.length < 2)
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }
 
    
        e.target.innerHTML = "...";
      

        props.mainView.setProgress(-2);

        var req =  row;


        fetch( Config.url + '/rest_v1,cloud_new', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    changeView();

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Zgłoszenie zostało wysłane" , "ok" , null);                                              
                       props.onSuccess();
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }



    const changeView = () => {
        if(view == 'btn') 
        {

            getDataPlGr();

            setView("dlg"); 

            setRow({
                nazwa:  "",  
                nazwa_valid:  false,  
                grupy: [],
                rodzice: 0,
                pracownicy: 0,
            });

        }  else setView('btn');
    }     

 


    var dlg_view =  (

            <div className="dlg_window dlg_type_x shadowx">

                    <div className="dlg_title">
                        Nowy katalog
                    </div>


                    <div className="dlg_content_x">


                                    <div className="form_tab">

                                     

                                        <div className="form_control">
                                            <div className="fieldName">Nazwa*</div>
                                            <InputText   userData={props.userData} value={row.nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: np. występ dzieci "} className=' w300 ' req='1' firstUp="1" />
                                        </div>

                                        <div className="form_split"></div>

                                        <b>Dostęp dla osób powiązanych z: </b>

                                        <div className="form_split"></div>
                                    
                                        <div>

                                                <div className="form_control">                                                         
                                                            <InputChecbox  title="Pracownicy"  err={errTab}  userData={props.userData}  checked={row.pracownicy} value={"1"} valChange={valChangeListener}  name={ "pracownicy"  }   className=' ' req='0' />
                                                    </div>                                    
                                                    
                                                    <div className="form_control">                                                         
                                                            <InputChecbox  title="Rodzice"  err={errTab}  userData={props.userData}  checked={row.rodzice} value={"1"} valChange={valChangeListener}  name={ "rodzice"  }   className=' ' req='0' />
                                                    </div> 
                                                    
                                        </div>

                                        <div className="form_split"></div>
                                
                                      
                            
                                                
                                            {
                                                    plgr.result.map( (item, ix) => {  

                                                            return (
                                                                <div>
                                                                    { 
                                                                        item.grupy.map(  (gr, ixpl) => {


                                                                            if(item.id != props.userData.p_przedszkole_id)
                                                                            {
                                                                                return null;
                                                                            }

                                                                            var cc = false;

                                                                            for(var mm =0; mm<row.grupy.length; mm++)
                                                                            {
                                                                                if(row.grupy[mm] == gr.id) cc = true;
                                                                            }

                                                                            return (
                                                                                <div className="form_control">                                                         
                                                                                    <InputChecbox  title={gr.nazwa}  err={errTab}  userData={props.userData}  checked={cc} value={ gr.id } valChange={valChangeListener}  name={ "grupy@"+ixpl  }   className=' ' req='0' />
                                                                                </div> 
                                                                            )


                                                                            } )
                                                                    }
                                                                </div>
                                                            )                                                             

                                                    } )
                                            }
                            
                                        
                                      

                                        <div className="form_split"></div>
                                
 
                                   

                                        <div className="form_split">                                       
                                        </div>

                                        <div className="form_control">                                            
                                            <div className="btn" onClick={saveData}>utwórz</div>
                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={changeView}>anuluj</div>
                                        </div>

                                        <br/>&nbsp;
                                        </div>

                    </div>

                
            </div>
    );

    if(view == 'btn') dlg_view = null;


    return  <div>
                <div className="btn"    onClick={changeView} >nowy katalog (+)</div> 
                {dlg_view} 
           </div>
}


export default CloudNew;